import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, Card } from "@/components/admin/AdminUI";
import { Input } from "@/components/ui/input";

export default function Settings() {
  const [s, setS] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings").then(({ data }) => setS(data || {})).catch(() => {}); }, []);
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const setSeo = (k) => (e) => setS({ ...s, seo: { ...(s.seo || {}), [k]: e.target.value } });

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings", s); toast.success("Paramètres enregistrés"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const Field = ({ label, k, seo }) => (
    <div><label className="text-sm text-slate-300">{label}</label>
      <Input value={(seo ? s.seo?.[k] : s[k]) || ""} onChange={seo ? setSeo(k) : set(k)} className="mt-1.5 bg-[#0B0F17] border-[#1E293B] text-white" /></div>
  );

  return (
    <div>
      <PageHeader title="Paramètres" subtitle="Informations de l'entreprise et configuration du site."
        action={<button onClick={save} disabled={saving} data-testid="settings-save-button" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#3B82F6] text-white text-sm font-semibold disabled:opacity-60"><Save className="w-4 h-4" /> Enregistrer</button>} />
      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="p-6 space-y-4">
          <h3 className="font-semibold text-white">Informations entreprise</h3>
          <Field label="Nom" k="company_name" />
          <Field label="Signature" k="signature" />
          <Field label="Adresse" k="address" />
          <Field label="Téléphone" k="phone" />
          <Field label="Email" k="email" />
          <div><label className="text-sm text-slate-300">Numéro WhatsApp (format international sans +)</label><Input value={s.whatsapp || ""} onChange={set("whatsapp")} className="mt-1.5 bg-[#0B0F17] border-[#1E293B] text-white" placeholder="2250798647783" /></div>
          <Field label="Horaires" k="hours" />
        </Card>
        <div className="space-y-6">
          <Card className="p-6 space-y-4">
            <h3 className="font-semibold text-white">Identité visuelle</h3>
            <div className="flex items-center gap-4">
              <div><label className="text-sm text-slate-300">Couleur principale</label><Input type="text" value={s.primary_color || "#0F2A6B"} onChange={set("primary_color")} className="mt-1.5 bg-[#0B0F17] border-[#1E293B] text-white" /></div>
              <div><label className="text-sm text-slate-300">Couleur accent</label><Input type="text" value={s.accent_color || "#4CB944"} onChange={set("accent_color")} className="mt-1.5 bg-[#0B0F17] border-[#1E293B] text-white" /></div>
            </div>
            <Field label="Devise" k="currency" />
          </Card>
          <Card className="p-6 space-y-4">
            <h3 className="font-semibold text-white">SEO global</h3>
            <Field label="Meta title" k="meta_title" seo />
            <Field label="Meta description" k="meta_description" seo />
            <Field label="Mots-clés" k="keywords" seo />
          </Card>
        </div>
      </div>
    </div>
  );
}
